var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},_vm._l((_vm.getPills),function(pill){return _c('div',{staticClass:"mr-5 mb-2 text-center"},[_c('vs-chip',{class:pill.color},[_vm._v(_vm._s(pill.title))]),_c('br'),(pill.desc != 'Pendiente')?_c('span',{staticClass:"text-sm"},[_vm._v(_vm._s(pill.desc))]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }